export type Scale5 = 1 | 2 | 3 | 4 | 5;
export type PartnerStatus = 'solo' | 'dating' | 'vanilla-partner' | 'kinky-partner';
export type Experience = 'none' | 'some-scenes' | 'ongoing-dynamic';
export type Dose = 'bedroom' | 'relationship' | 'lifestyle' | 'tpe';

export interface Inputs {
  lifeFullness: Scale5;
  energy: Scale5;
  partnerStatus: PartnerStatus;
  hoursPerWeek: number;
  supportSystems: Scale5;
  experience: Experience;
  lifeStability: Scale5;
  riskTolerance: Scale5;
  curiosityVsCommitment: Scale5;
  desiredMinDose: Dose;
}

export interface Recommendation {
  dose: Dose;
  score: number;
  /** 0..1 — how confidently we land at this dose vs the neighboring one */
  confidence: number;
  warnings: string[];
}

export const DOSE_ORDER: Dose[] = ['bedroom', 'relationship', 'lifestyle', 'tpe'];

export const DOSE_LABELS: Record<Dose, string> = {
  bedroom: 'bedroom only',
  relationship: 'relationship style',
  lifestyle: 'lifestyle',
  tpe: 'total power exchange',
};

export const DOSE_DESCRIPTIONS: Record<Dose, string> = {
  bedroom:
    'scenes by appointment. the rest of life is unchanged. the dynamic lives in defined moments, not the in-between.',
  relationship:
    'a flavor that runs through the partnership. small daily rituals, a recognizable shape, but most of life remains itself.',
  lifestyle:
    'daily life is shaped across multiple domains — habits, schedules, attire, language. the dynamic is the default texture.',
  tpe:
    "authority extends across nearly all of life. one person's preferences shape the other's calendar, body, choices. not a starting point.",
};

export const DEFAULT_INPUTS: Inputs = {
  lifeFullness: 3,
  energy: 3,
  partnerStatus: 'solo',
  hoursPerWeek: 6,
  supportSystems: 3,
  experience: 'none',
  lifeStability: 3,
  riskTolerance: 3,
  curiosityVsCommitment: 2,
  desiredMinDose: 'bedroom',
};
